<template>
  <div :data-item-id="item._id" class="box-interactions">
    <md-card class="md-card-plain">
      <div class="user-data">
        <div class="md-layout md-gutter-sm md-alignment-center-left">
          <div class="md-layout-item">
            <img
              class="user-avatar md-round"
              src="/img/avatars/avatar-user-profile-default.png"
              alt="avatar user profile"
            />
          </div>
          <div class="md-layout-item user-info">
            <div class="user-name">
              <!-- {{ item.startedBy.name || 'Anonymous' }} -->
              <small class="date-interaction">
                {{
                  displayTimeZone(
                    item.replacedDate || item.createdAt,
                    'DD/MM/YYYY [at] h:mm A',
                  )
                }}
              </small>
              <small>
                {{
                  item.startedBy.channel
                    ? ` | By ${item.startedBy.channel}`
                    : ''
                }}
              </small>
              <br />
            </div>
          </div>
        </div>
      </div>

      <div class="interaction-card">
        <md-card-header class="header-interactions">
          <div class="md-layout md-gutter-sm md-alignment-center-left">
            <div class="md-layout-item">
              <div class="avatar">
                <img :src="image" alt="avatar task" />
                <span :class="'rfider-status-' + item.status + '-color'"></span>
              </div>
            </div>
            <div class="md-layout-item title-interaction">
              {{ getTranslatedText(item.title) }}
              <div v-if="blockchainIntegrations">
                <span>
                  <md-chip
                    >Blockchain
                    <md-icon class="md-size-small">info</md-icon></md-chip
                  >
                  <md-tooltip md-direction="bottom">{{
                    blockchainIntegrations.join(', ')
                  }}</md-tooltip>
                </span>
              </div>
              <div
                v-if="item.valueChainElement && item.valueChainElement.name"
                class="value-chain-name"
              >
                <small>{{ item.valueChainElement.name }}</small>
              </div>
            </div>

            <div
              class="md-layout-item md-layout-item--no-grow"
              v-if="isEventGalleryInteraction && firstEventGalleryImage"
            >
              <md-button
                class="md-simple md-just-icon attaches"
                @click="openModal = !openModal"
              >
                <md-icon>image</md-icon>
              </md-button>
            </div>

            <div class="md-layout-item md-layout-item--no-grow">
              <md-button
                v-if="item.steps"
                class="md-simple md-just-icon btn-expand"
                @click="toggleExpand"
              >
                <md-icon>expand_more</md-icon>
              </md-button>
            </div>
          </div>
        </md-card-header>

        <md-content
          class="md-scrollbar stepflow-interactions"
          v-show="item._stateOpened"
        >
          <div class="steps" v-for="(step, index) in item.steps" :key="index">
            <div class="md-layout md-gutter-sm md-alignment-top-left">
              <div class="md-layout-item" :class="'step-status-' + step.status">
                <md-icon v-if="step.status == 0">error</md-icon>
                <md-icon v-else class="md-size-small md-icon-dot"></md-icon>
              </div>
              <div
                class="md-layout-item title-interaction step-title step-link"
                :class="[{ 'step-description': step.description }]"
                v-if="step.stepLink"
              >
                <a href @click.prevent="searchStep(step.stepLink)">
                  {{ getTranslatedText(step.name) }}
                  <br />
                  <small v-if="step.description">
                    {{ getStatus(step.description) || step.description }}
                  </small>
                </a>
                <a
                  href
                  @click.prevent="searchStep(step.stepLink)"
                  class="step-link-icon"
                >
                  <md-icon class="md-size-1-5px">arrow_right</md-icon>
                </a>
              </div>
              <div
                v-else
                class="md-layout-item title-interaction step-title"
                :class="[{ 'step-description': step.description }]"
              >
                {{ getTranslatedText(step.name) }}
                <br />
                <!-- eslint-disable -->
                <small v-if="step.description" class="public-interaction-description-content"
                  v-html="getStatus(step.description) || step.description">
                </small>
                <!--eslint-enable-->
              </div>

              <!-- <div
                v-if="step.metadata && step.metadata.attachments.length"
                class="md-layout-item md-layout-item--no-grow"
              >
                <md-button
                  class="md-simple md-just-icon attaches"
                  @click="openAttachmentsGallery(step)"
                >
                  <md-icon>attach_file</md-icon>
                  <span class="notification">
                    {{ step.metadata.attachments.length }}
                  </span>
                </md-button>
              </div> -->
            </div>
          </div>
          <div v-if="item.actions">
            <div
              class="step-changed"
              v-for="(action, index) in item.actions"
              :key="index"
            >
              {{ $t('interaction_action_' + action.type) }}
              <span>
                {{ getStatus(action.message) || action.message }}
              </span>
            </div>
            <!-- <div
              class="step-changed"
              v-if="item.status >= 0 && item.statusMessage"
            >
              {{ $t('interaction_action_0') + ' ' }}
              <span> {{ item.statusMessage }}</span>
            </div> -->
          </div>
        </md-content>

        <md-card-header class="footer-interactions">
          <div class="md-layout md-gutter-sm md-alignment-center-left">
            <div class="md-layout-item md-size-5 md-xsmall-size-15 batch-icon">
              <img
                v-if="item.batchId && item.batchEnabled"
                class="public-interactions-batch-record"
                src="/img/icons/Batch-Record-Indicator.png"
              />
            </div>
            <div v-if="enrichedData" class="md-layout-item whether-info">
              {{ enrichedData.location }}
              <br />
              {{ enrichedData.weather }}
            </div>
          </div>
        </md-card-header>
      </div>
    </md-card>

    <public-interactions-event-gallery
      :open-modal="openModal"
      :item="item"
      :task-img-promise="taskImgPromise"
      @toggle-dialog="toggleDialog"
    ></public-interactions-event-gallery>
  </div>
</template>

<script>
import timeZone from '@/mixins/timeZone';
import PublicInteractionsEventGallery from './../public/publicInteractionsEventGallery.vue';

export default {
  mixins: [timeZone],
  components: {
    PublicInteractionsEventGallery,
  },
  props: {
    item: Object,
    taskImgPromise: { type: Function },
  },
  data() {
    return {
      enrichedData: null,
      openModal: false,
    };
  },
  asyncComputed: {
    async image() {
      let img = null;
      const taskId = this.item ? this.item.taskId : null;
      if (taskId && this.taskImgPromise) {
        img = await this.taskImgPromise(taskId);
      }
      return img
        ? this.mixinGetFilePath(img, 'O')
        : '/img/avatars/avatar-task-default.png';
    },
  },
  computed: {
    blockchainIntegrations() {
      const arr = [];
      const tags = this.item.tags || [];
      tags.forEach((t) => {
        if (t === 'integration-ibmFoodTrust') {
          arr.push('IBM Food Trust');
        }
      });
      return arr.length ? arr : null;
    },
    isEventGalleryInteraction() {
      return !!(
        this.item.showEventGallery &&
        Array.isArray(this.item.tags) &&
        this.item.tags.includes('eventGallery')
      );
    },
    firstEventGalleryImage() {
      let firstEventGalleryImage = null;

      // Checking interaction images
      const interactionImages = this.extractAttachmentsImages(this.item);
      if (interactionImages.length) {
        firstEventGalleryImage = this.mixinGetFilePath(
          interactionImages[0].src,
          'S',
        );
      } else {
        // Checking interaction steps's images
        if (this.item.steps) {
          for (const step of this.item.steps) {
            const stepImages = this.extractAttachmentsImages(step);
            if (stepImages.length) {
              firstEventGalleryImage = this.mixinGetFilePath(
                stepImages[0].src,
                'S',
              );
              break;
            }
          }
        }
      }

      return firstEventGalleryImage;
    },
  },
  watch: {
    item: {
      immediate: true,
      handler(newItem) {
        if (newItem.metadata) {
          const { temp, rh, aqi } = newItem.metadata.location.weather || {};
          const locationDetails = newItem.metadata.replacedLocation
            ? newItem.metadata.replacedLocation.details
            : newItem.metadata.location.details;

          this.enrichedData = {};
          this.enrichedData.location = this.extractLocationData(
            locationDetails || {},
          );

          if (temp && rh && aqi) {
            this.enrichedData.weather =
              `${temp}°C` + ' | ' + `RH ${rh}%` + ' | ' + `AQI ${aqi}`;
          } else {
            this.enrichedData.weather = 'Weather Unavailable';
          }
        } else {
          this.enrichedData = null;
        }
      },
    },
  },
  methods: {
    toggleExpand() {
      // eslint-disable-next-line vue/no-mutating-props
      this.item._stateOpened = !this.item._stateOpened;
    },
    toggleDialog() {
      this.openModal = !this.openModal;
    },
    extractAttachmentsImages(object) {
      let images = [];
      if (object.metadata && Array.isArray(object.metadata.attachments)) {
        object.metadata.attachments.forEach((attachment) => {
          if (this.mixinGetImageRegex().test(attachment.file)) {
            images.push({
              src: attachment.file,
            });
          }
        });
      }
      // images = images.concat(this.fakeData);
      return images;
    },
    searchStep(stepInfo) {
      window.open(stepInfo, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/public/_interactions-item.scss';
</style>
